module.exports = __webpack_public_path__ + "static/media/20cent.fde85722.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/20cent.png
// module id = 925
// module chunks = 0